/**
 * Redimensionne une image côté client via un canvas et l'exporte en JPEG.
 * Utilisé avant l'upload d'avatar (page Réglages + modale d'infos profil).
 * @param maxWidth largeur max en px (l'image n'est jamais agrandie)
 * @param quality qualité JPEG de 0 à 1
 */
export function resizeImage(file: File, maxWidth: number, quality: number): Promise<File> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;
      img.onload = () => {
        const scaleFactor = maxWidth / img.width;
        const newWidth = Math.min(img.width, maxWidth);
        const newHeight = img.height * (img.width > maxWidth ? scaleFactor : 1);

        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;
        const ctx = canvas.getContext('2d');

        ctx?.drawImage(img, 0, 0, newWidth, newHeight);

        canvas.toBlob((blob) => {
          if (blob) {
            const resizedFile = new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            resolve(resizedFile);
          } else {
            reject(new Error('Canvas to Blob conversion failed'));
          }
        }, 'image/jpeg', quality);
      };
      img.onerror = (error) => reject(error);
    };
    reader.onerror = (error) => reject(error);
  });
}
